module.exports = __webpack_public_path__ + "img/418917155.4980e01b.jpg";